import * as wjcCore from '@mescius/wijmo';
import * as wjcGrid from '@mescius/wijmo.grid';
declare var Stimulsoft: any;

'use strict';

import {ViewChild, Component, OnInit} from '@angular/core';
import {FormBuilder} from "@angular/forms";
import {ToasterService} from "angular2-toaster";
import {TranslocoService} from '@jsverse/transloco';

import {ActivePromotionConfig} from "../config/active-promotion.config";
import {FormHelperService} from "../services/form-helper.service";
import {DataService} from "@cosbeni/database";
import {ConfirmComponent} from "../ui/modal";
import {StimulsoftFontService} from "../services/stimulsoft-font.service";

@Component({
    standalone: false,
    selector: 'cj-admin-report',
    templateUrl: 'report-management.component.html'
})

export class ReportManagementComponent implements OnInit {
    designer: any;
    designerOptions: any;
    viewer: any;
    viewerOptions: any;
    report: any;
    reports: any = [];
    name: string = "";
    mode: string = "viewer";
    private readonly: Boolean = true;
    @ViewChild('grid') grid: wjcGrid.FlexGrid;
    @ViewChild('removeReportPopup') removeReportPopup: ConfirmComponent;

    constructor(public dataService: DataService, public toasterService: ToasterService, public formHelper: FormHelperService, public formBuilder: FormBuilder, private stimulsoftFontService: StimulsoftFontService, private transloco: TranslocoService) {
    }

    ngOnInit() {
        Stimulsoft.Base.StiLicense.Key = "6vJhGtLLLz2GNviWmUTrhSqnOItdDwjBylQzQcAOiHl26ZSMEMFmk3V4cVIW/z4aEPCZyhHy36IUIO31u64kPjupS5" +
            "RJ4Kkjh5zA8Js69gML1a/uLIe1uPsavO7G5SbuLvcEW0DcE58buMSZAh4scMesvQVrMM5AkiDUBomhUQfwCMrOWHM9" +
            "61Nb0khu5OVxh450w7X/qNMLW/Ncr+Djtsa1cbZzEQ4r7VkoHy7uZEPVVX9G3Qqtt/dB0cY62D4SY5Zal1nD/bV66S" +
            "3ok4BE+uUYDR5LQ+Yr1dtr+aM/BJUdeMdY6UGOaMthyAGzcyJ1CfV+9AQNrprnDoMQLK83sxIpn5aTSX/p/LNdTCZa" +
            "gpBGH4fp2hjcWVrAsVgkNVsL9zaA0v83O3CtoSlmJLK7M7IAmtsV3fyy3LRo6PlMmBmsPJMbsfQdIj9krxN3Hx9IEQ" +
            "QpIyo+/vGqtsCpDAFfQAmcv6UfTYw0j3XWdoiRQWNBhOjx1jRZwogSJ0wzdVnqa78HySzEfTFNpyWyiPFl7WBxTNnB" +
            "wAVazg9gu7dVCbvUJJA+BRdINej8KErdRgfy";
        // フォント/ローカライズは StimulsoftFontService が 1 回だけ非同期登録する (ira issue #151 と同対応)
        this.stimulsoftFontService.ensureLoaded();
        this.viewerOptions = new Stimulsoft.Viewer.StiViewerOptions();
        this.viewerOptions.appearance.scrollbarsMode = false;
        this.viewer = new Stimulsoft.Viewer.StiViewer(this.viewer, 'StiViewer', false);
        this.designerOptions = new Stimulsoft.Designer.StiDesignerOptions();
        this.designerOptions.appearance.fullScreenMode = false;
        this.designerOptions.appearance.showSystemFonts = false;
        this.designer = new Stimulsoft.Designer.StiDesigner(this.designerOptions, 'StiDesigner', false);
        this.report = new Stimulsoft.Report.StiReport();
        this.loadReports();
    }

    loadReports(): void {
        this.dataService.query({
            sql: "SELECT FROM DA_Report ORDER BY name",
            count: "SELECT FROM DA_Report ORDER BY name",
            fetchPlan: "*:1",
        }, ActivePromotionConfig.SERVER_URL).subscribe(data => {
            this.reports = wjcCore.asArray(data.results);
            if(this.reports.length > 0){
                this.name = this.reports[0].name;
            }
        })
    }


    saveReport(): void {
        let json: any = {};
        json.name = this.name;
        if(this.mode == "viewer"){
            json.content = JSON.parse(this.viewer.report.saveToJsonString());
        } else {
            json.content = JSON.parse(this.designer.report.saveToJsonString());
        }
        json.content['@type'] = 'd'
        delete json.content.Styles;
        let sql = "BEGIN\n"
        for (let item of this.reports) {
            if (item.name == this.name) {
                json['@rid'] = item['@rid'];
            }
        }
        if (json.hasOwnProperty("@rid")) {
            sql = sql + "UPDATE DA_Report SET name = '" + this.name + "',content=" + JSON.stringify(json.content) + " WHERE name = '" + this.name + "'\n";
        } else {
            sql = sql + "INSERT INTO DA_Report SET name ='" + this.name + "',content=" + JSON.stringify(json.content) + "\n";
        }
        sql = sql + "COMMIT RETRY 100\n";
        this.dataService.batch({sql: sql}, ActivePromotionConfig.SERVER_URL).subscribe((response: any) => {
            this.toasterService.pop('info', this.transloco.translate('common.save'), this.transloco.translate('admin.saved_message'));
            this.loadReports();
        }, (error: any) => {
            this.toasterService.pop('error', this.transloco.translate('common.save'), this.transloco.translate('admin.failed_message'));
        })
    }

    async displayReport(): Promise<void> {
        await this.stimulsoftFontService.ensureLoaded();
        this.mode = "viewer";
        for (let item of this.reports) {
            if (item.name == this.name) {
                let r = {...item.content};
                delete r['@type'];
                delete r['@version'];
                this.report.load(r);
                document.getElementById("viewerContent").innerHTML = "";
                document.getElementById("designerContent").innerHTML = "";
                this.viewer.report = this.report;
                this.viewer.renderHtml("viewerContent");
            }
        }
    }

    async editReport(): Promise<void> {
        await this.stimulsoftFontService.ensureLoaded();
        this.mode= "designer";
        for (let item of this.reports) {
            if (item.name == this.name) {
                let r = {...item.content};
                delete r['@type'];
                delete r['@version'];
                this.report.load(r);
                document.getElementById("viewerContent").innerHTML = "";
                document.getElementById("designerContent").innerHTML = "";
                this.designer.report = this.report;
                this.designer.renderHtml('designerContent');
            }
        }
    }

    confirmRemoveReport(): void {
        this.removeReportPopup.modal.show();
    }

    removeReport(): void {
        for (let item of this.reports) {
            if (item.name == this.name) {
                let command = "DELETE VERTEX " + item['@rid'];
                this.dataService.command({sql: command}, ActivePromotionConfig.SERVER_URL).subscribe((response: any) => {
                        this.toasterService.pop('info', this.transloco.translate('common.delete'), this.transloco.translate('admin.deleted_message'));
                        this.loadReports();
                    },
                    (error) => {
                        this.toasterService.pop('error', this.transloco.translate('common.delete'), this.transloco.translate('admin.failed_message'));
                    })
            }
        }
    }
}

